// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 13C14.4 13 16.58 13.69 18.18 14.67 18.98 15.16 19.66 15.73 20.16 16.36 20.65 16.97 21 17.71 21 18.5 21 19.34 20.59 20.01 20 20.49 19.44 20.94 18.7 21.24 17.92 21.44 16.34 21.86 14.23 22 12 22S7.66 21.86 6.09 21.44C5.3 21.23 4.57 20.93 4.01 20.49 3.41 20.01 3 19.34 3 18.5 3 17.71 3.36 16.98 3.84 16.36 4.33 15.74 5.02 15.16 5.82 14.67 7.42 13.7 9.61 13 12 13M12 2A5 5 0 1 1 12 12 5 5 0 0 1 12 2"/>';

/** Profile (account). */
const icon: IconData = {
  id: "user",
  name: "Profile",
  category: "account",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-width="2" d="M20 18.5C20 20.43 16.42 21 12 21S4 20.43 4 18.5 7.58 14 12 14 20 16.57 20 18.5ZM16 7A4 4 0 1 1 8 7 4 4 0 0 1 16 7Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.93 13L13.82 13.14 15.45 13.49 16.93 14.03 18.24 14.71 19.35 15.53 20.23 16.46 20.69 17.23 20.98 18.29 20.97 18.74 20.81 19.4 20.6 19.81 19.88 20.57 18.96 21.09 17.86 21.45 16.59 21.71 15.18 21.88 11.98 22 8.77 21.87 7.32 21.7 6.02 21.42 4.86 21 3.87 20.36 3.4 19.81 3.19 19.4 3.03 18.74 3.02 18.29 3.31 17.23 3.91 16.28 4.78 15.42 5.88 14.64 7.19 13.97 8.68 13.45 10.32 13.12ZM11.9 2L13.1 2.13 14.03 2.44 14.87 2.91 15.6 3.54 16.2 4.29 16.64 5.15 16.91 6.09 17 7.1 16.87 8.1 16.57 9.03 16.09 9.87 15.46 10.6 14.71 11.2 13.85 11.64 12.91 11.91 11.9 11.99 10.9 11.87 9.97 11.56 9.13 11.09 8.4 10.46 7.8 9.71 7.36 8.85 7.09 7.91 7 6.9 7.13 5.9 7.43 4.97 7.91 4.13 8.54 3.4 9.29 2.8 10.15 2.36 11.09 2.09Z"/></g><path fill="none" stroke="currentColor" stroke-width="2" d="M20 18.5C20 20.43 16.42 21 12 21S4 20.43 4 18.5 7.58 14 12 14 20 16.57 20 18.5ZM16 7A4 4 0 1 1 8 7 4 4 0 0 1 16 7Z"/>',
    },
  },
  animation: () => import("../animations/user.js"),
};

export default icon;
